import {
  Box,
  Flex,
  Image,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import i18next from "i18next";
import { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { COMMON_WEB_PATH } from "../../../constant";
import { routeMappingV4 } from "./utils/routeMapping_v4";
const GameTypeSelector = ({ gameMainTypeFromProps, ltr } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const textColor = useColorModeValue("dark.100", "light.100");

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { gameType, gameList } = isHandleAllGame || {};

  const splideRef = useRef();

  const location = useLocation();

  const { pathname } = location;

  //   const getGameType = useMemo(() => {
  //     return pathname.split("/")[1];
  //   }, [pathname]);
  const { gameMainType } = useParams();

  //顯示的遊戲類型
  const combileType = useMemo(() => {
    if (gameType) {
      // 定義要保留的遊戲類型
      const allowedTypes = [
        "SLOT",
        "LIVE",
        // "BINGO",
        "FH",
        // "SPORT",
        "TABLE",
        "BLOCKCHAIN",
      ];
      //   // 過濾 gameType，只保留 allowedTypes 中的類型
      //   const filteredGameType = gameType.filter((type) =>
      //     allowedTypes.includes(type)
      //   );
      // 過濾 gameType，只保留 allowedTypes 中的類型，並按照 allowedTypes 的順序排序
      const filteredGameType = allowedTypes.filter((type) =>
        gameType.includes(type)
      );

      return ["LOBBY", ...filteredGameType];
    }
    return [];
  }, [gameType]);

  const gameSubTypeList = useMemo(() => {
    if (gameType) {
      return [
        ...combileType.map((item, index) => {
          const { link } = routeMappingV4(item);
          const current_game_type = routeMappingV4(item)?.origin;

          const totalLength = combileType.length;

          const itemChildren = (
            <Link
              as={(props) => <NavLink {...props} />}
              to={`${link}`}
              _hover={{
                textDecoration: "none",
              }}
              display="flex"
              justifyContent={"center"}
              alignItems={"center"}
            >
              {(props) => {
                const { isActive } = props;
                return (
                  <Flex
                    role="group"
                    direction="column"
                    alignItems={"center"}
                    position="relative"
                    w={"100%"}
                    h="100%"
                    justifyContent="center"
                    transition="all 0.3s"
                  >
                    <Box
                      position="relative"
                      // width={item === "LIVE" ? "80px" : "71px"} // 根據圖片原始寬度設定
                      w="100%"
                      h="100%"
                      display="flex"
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent="center"
                    >
                      <Box
                        position="relative"
                        _after={
                          isActive
                            ? {
                                content: "''",
                                bgImage: `${COMMON_WEB_PATH}/theOne/gameType/active_arrow.png`,
                                bgSize: "100%100%",
                                position: "absolute",
                                top: "50%",
                                left: "0%",
                                transform: "translate(-50%,-50%)",
                                w: "15px",
                                h: "15px",
                              }
                            : {}
                        }
                      >
                        <Image
                          src={`${COMMON_WEB_PATH}/theOne/gameType/M_${current_game_type?.toUpperCase()}${
                            isActive ? "_active" : ""
                          }.png`}
                          width="90%"
                          height="100%"
                          _groupHover={{
                            src: `${COMMON_WEB_PATH}/5285/gameType${
                              i18next.language == "tw"
                                ? ""
                                : `/${i18next.language}`
                            }/M_${current_game_type?.toUpperCase()}_active_2.png?11`,
                          }}
                        />
                      </Box>
                      <Text
                        fontWeight={"500"}
                        fontSize="14px"
                        textShadow={"0 0 1px white"}
                        className="text-overflow"
                      >
                        {i18n(current_game_type)}
                      </Text>
                    </Box>
                  </Flex>
                );
              }}
            </Link>
          );
          return <SplideSlide key={index}>{itemChildren}</SplideSlide>;
        }),
      ];
    }
  }, [gameType, i18next.language, gameList, combileType, textColor, ltr]);

  const findCurrentGameTypeIndex = useMemo(() => {
    const mainType = gameMainTypeFromProps || gameMainType;

    const processGameType = gameType?.map((item) => {
      const textMapping = routeMappingV4(item);

      return textMapping?.link.replace("/", "");
    });

    return processGameType?.indexOf(mainType);
  }, [gameType, gameMainType, gameMainTypeFromProps]);

  useEffect(() => {
    if (splideRef.current) {
      const mainType = gameMainTypeFromProps || gameMainType;
      const splide = splideRef.current.splide;
      const processGameType = gameType?.map((item) => {
        const textMapping = routeMappingV4(item);
        return textMapping?.link.replace("/", "");
      });
      splide.go(processGameType?.indexOf(mainType));
    }
  }, [gameType, gameMainType, gameMainTypeFromProps]);

  return (
    <Box
      position={"relative"}
      h={{
        base: "calc(100vh - 220px)",
        md: "100%",
      }}
      overflow={"scroll"}
    >
      <Splide
        ref={splideRef}
        options={{
          start: findCurrentGameTypeIndex,
          pagination: false,
          type: "slide",
          arrows: false,
          // drag: "free",
          // perPage: 5,
          // perMove: 1,
          gap: "10px",
          direction: "ttb",
          perPage: 5,
          perMove: 1,
          height: "calc(100%)",
          // fixedWidth: `${100 / combileType?.length}%`,
          fixedWidth: "70px",
        }}
      >
        {gameSubTypeList}
      </Splide>
    </Box>
  );
};

export default GameTypeSelector;
